import { direction_type } from '../types';
import { fetchAttachment } from 'services/searchEmail.service';
import { uiToApi } from './forms/statusData';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Utils from 'utilities/helper.util';
dayjs.extend(customParseFormat);

export const filterStr = ({ formData, direction }: any) => {
  const filteredString = Object.entries(formData).reduce(
    (accumulator: any, currentValue: any) => {
      switch (currentValue[0]) {
        case 'subjectContains':
          return `${accumulator},subject:%${currentValue[1]}%`;
        case 'recipientContains': {
          return direction === direction_type.INBOUND
            ? `${accumulator},from:%${currentValue[1]}%`
            : `${accumulator},to:%${currentValue[1]}%`;
        }
        case 'from': {
          const fromDate = currentValue[1];
          const { timeFrom, amPmFrom } = formData;
          let formattedDate;
          if (timeFrom) {
            formattedDate = dayjs(
              `${fromDate} ${timeFrom} ${amPmFrom}`,
              'DD/MM/YYYY h:mm A'
            );
          } else {
            formattedDate = dayjs(fromDate, 'DD/MM/YYYY');
          }
          return `${accumulator},createdAfter:${formattedDate.toISOString()}`;
        }
        case 'to': {
          const toDate = currentValue[1];
          const { timeTo, amPmTo } = formData;
          const isToday = checkIfDateRangeIsToday(toDate, timeTo, amPmTo);
          let formattedDate;
          if (timeTo) {
            formattedDate = !isToday
              ? dayjs(`${toDate} ${timeTo} ${amPmTo}`, 'DD/MM/YYYY h:mm A')
              : dayjs(
                  `${toDate} ${timeTo} 59 ${amPmTo}`,
                  'DD/MM/YYYY h:mm:ss A'
                );
          } else {
            formattedDate = dayjs(toDate, 'DD/MM/YYYY');
          }
          return `${accumulator},createdBefore:${formattedDate.toISOString()}`;
        }
        case 'status': {
          let statusCombined: string = currentValue[1].reduce(
            (accumulator: any, currentValue: any) => {
              const statusValue:
                | 'Bounced'
                | 'Deferred'
                | 'Delivered'
                | 'Dropped'
                | 'Opened'
                | 'Processed'
                | 'Spamreport'
                | 'Unsubscribed'
                | 'Clicked' = currentValue;
              return `${accumulator}|${uiToApi[statusValue]}`;
            },
            ''
          );
          statusCombined = statusCombined.substring(1);
          return direction === direction_type.INBOUND
            ? `${accumulator}`
            : `${accumulator},status:${statusCombined}`;
        }
        default:
          return accumulator;
      }
    },
    ''
  );
  return filteredString.substring(1);
};

export const filterStringReducer = (accumulator: any, currentValue: any) => {
  const [key, value] = currentValue;

  switch (key) {
    case 'dateFrom':
      accumulator = value ? { ...accumulator, from: value } : accumulator;
      break;
    case 'dateTo':
      accumulator = value ? { ...accumulator, to: value } : accumulator;
      break;
    case 'recipientContains': {
      accumulator = value
        ? { ...accumulator, recipientContains: value }
        : delete accumulator.recipientContains && accumulator;
      break;
    }
    case 'subjectContains': {
      accumulator = value
        ? { ...accumulator, subjectContains: value }
        : delete accumulator.subjectContains && accumulator;
      break;
    }
    case 'status': {
      accumulator =
        value && value?.length > 0
          ? {
              ...accumulator,
              status: value
            }
          : accumulator;
      break;
    }
    case 'hourTo': {
      accumulator = value
        ? {
            ...accumulator,
            timeTo: value
          }
        : accumulator;
      break;
    }
    case 'hourFrom': {
      accumulator = value
        ? {
            ...accumulator,
            timeFrom: value
          }
        : accumulator;
      break;
    }
    case 'amPmTo': {
      accumulator = value
        ? {
            ...accumulator,
            amPmTo: value
          }
        : accumulator;
      break;
    }
    case 'amPmFrom': {
      accumulator = value
        ? {
            ...accumulator,
            amPmFrom: value
          }
        : accumulator;
      break;
    }
  }
  return accumulator;
};

export const isShowButton = (
  values: any,
  errors: any,
  statusOptions: string[] | undefined
): boolean => {
  return (
    !errors.recipientContains &&
    !errors.subjectContains &&
    !errors.hourFrom &&
    !errors.hourTo &&
    !errors.dateFrom &&
    !errors.dateTo &&
    (values.subjectContains ||
      values.recipientContains ||
      values.dateFrom ||
      values.dateTo ||
      statusOptions?.length)
  );
};

export const getAttachment = async ({
  url,
  attachmentName,
  setApiError
}: {
  url: string;
  attachmentName: string;
  setApiError: any;
}) => {
  try {
    const response = await fetchAttachment({ url });
    const blob = await response.blob();
    const localUrl = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = localUrl;
    link.setAttribute('download', `${attachmentName}`);
    link.click();
    link?.parentNode?.removeChild(link);
  } catch (err) {
    setApiError(err);
  }
};

export const checkIfDateRangeIsToday = (
  toDate: string,
  timeTo: string,
  amPmTo: string
) => {
  const today = dayjs(Utils.getTodayDate(), 'DD/MM/YYYY');
  const toDateObj = dayjs(toDate, 'DD/MM/YYYY');

  return (
    Utils.getDiffDates(today, toDateObj) === 0 &&
    timeTo === '11:59' &&
    amPmTo === 'PM'
  );
};
